import { defineMessages } from 'react-intl';

import { ToothType } from './tooth.type';

export const toothTypeMessages = defineMessages<ToothType>({
  unhealthy: {
    id: 'studyToothChart.unhealthy',
    defaultMessage: 'Unhealthy',
  },
  lowProbability: {
    id: 'studyToothChart.lowProbability',
    defaultMessage: 'Suspicious',
  },
  treated: {
    id: 'studyToothChart.treated',
    defaultMessage: 'Treated',
  },
  healthy: {
    id: 'studyToothChart.healthy',
    defaultMessage: 'Healthy',
  },
  missing: {
    id: 'studyToothChart.missing',
    defaultMessage: 'Missing',
  },
  all: {
    id: 'global.all',
    defaultMessage: 'All',
  },
});

export type FDAToothType = 'unhealthy' | 'treated' | 'healthy' | 'missing';

export const fdaToothTypeMessages = defineMessages<FDAToothType>({
  unhealthy: {
    id: 'studyToothChart.fda.suspiciousForConditions',
    defaultMessage: 'Suspicious for Conditions',
  },
  treated: {
    id: 'studyToothChart.treated',
    defaultMessage: 'Treated',
  },
  healthy: {
    id: 'studyToothChart.fda.noFindings',
    defaultMessage: 'No Findings',
  },
  missing: {
    id: 'studyToothChart.fda.missing',
    defaultMessage: 'Missing',
  },
});
